import { render } from "./EditableKeywordsPopup.vue?vue&type=template&id=16c7c7ce"
import script from "./EditableKeywordsPopup.vue?vue&type=script&lang=js"
export * from "./EditableKeywordsPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__